import type { ReactNode } from 'react';
import { useT } from './I18nProvider';
import type { Language } from './translations';

const LANGUAGES: ReadonlyArray<Language> = ['en', 'es'];

// A small EN/ES language switch for the shared header and the sign-in screen.
// Switching updates the i18n context (and localStorage) so all text re-renders
// immediately. The <select> carries an aria-label for accessibility.
export function LanguageToggle(): ReactNode {
  const { lang, setLang, t } = useT();

  return (
    <select
      className="language-toggle"
      aria-label={t('language.label')}
      value={lang}
      onChange={(e) => setLang(e.target.value as Language)}
    >
      {LANGUAGES.map((code) => (
        <option key={code} value={code}>
          {t(code === 'en' ? 'language.en' : 'language.es')}
        </option>
      ))}
    </select>
  );
}
